import { useQuery } from 'react-query';
import { service } from '../redux/api/axios';

export type TBranch = {
  _id: string;
  name: string;
  apiUrl: string[];
};

const useHook = () => {
  return useQuery(['branches'], async () => {
    const response = await service.get<TBranch[]>(`/branches`);
    return response.data;
  });
};

export default useHook;
